import React from "react";
import { Layout, Menu, Dropdown, Modal, Input } from "antd";
import { useLocation } from "react-router";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BrowserRouter as Router, Link, useNavigate } from "react-router-dom";
import images from "../themes/appImage";
import { useDispatch } from "react-redux";
import { changePasswordLoad, logoutLoad } from "../redux/slices/auth.slice";
import { checkAccess } from "../utils";

const { Sider } = Layout;
const Sidebar = (props) => {
  let navigate = useNavigate();
  const [modal7Open, setModal7Open] = useState(false);
  let location = useLocation();
  const dispatch = useDispatch();
  const onMenuClick = (e) => navigate(e.key);
  const handelLogout = () => {
    dispatch(logoutLoad());
  };
  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object().shape({
      oldPassword: Yup.string().required("Old password is required"),
      newPassword: Yup.string()
        .required("New password is required")
        .min(8, "Password must be at least 8 characters long")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(
          /[\W_]/,
          "Password must contain at least one special character"
        ),
      confirmPassword: Yup.string()
        .required("Confirm password is required")
        .oneOf([Yup.ref("newPassword")], "Passwords must match"),
    }),
    onSubmit: (values) => {
      dispatch(
        changePasswordLoad({
          oldPassword: values.oldPassword,
          password: values.newPassword,
        })
      );
      setModal7Open(false);
    },
  });

  const items = [
    {
      key: "1",
      label: (
        <div>
          <div className="flex items-center justify-center  p-2 ">
            <div className="text-base font-semibold">
              {localStorage.getItem("userName")}
            </div>
          </div>
          <div className=" border-b"></div>
        </div>
      ),
    },

    {
      key: "2",
      label: (
        <div
          className="flex  items-center justify-center p-2 "
          onClick={() => {
            setModal7Open(true);
          }}
        >
          {/* <img src={images.logout} alt="logout" /> */}
          <div className="text-sm text-dark font-normal">Change Password</div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div
          className="flex  items-center justify-center p-2 "
          onClick={handelLogout}
        >
          {/* <img src={images.logout} alt="logout" /> */}
          <div className="text-sm text-dark font-normal">Log out</div>
        </div>
      ),
    },
  ];

  let activeKey = "";
  switch (location.pathname) {
    case "/dashboard":
      activeKey = "/dashboard";
      break;
    case "/changepassword":
      activeKey = "/changepassword";
      break;

    case "/notificationmanagement":
      activeKey = "/notificationmanagement";
      break;

    case "/organizations":
      activeKey = "/organizations";
      break;

    case "/organizationssummary":
      activeKey = "/organizations";
      break;

    case "/departments":
      activeKey = "/departments";
      break;

    case "/users":
      activeKey = "/users";
      break;

    case "/addusers":
      activeKey = "/users";
      break;

    case "/community":
      activeKey = "/community";
      break;

    case "/innercircle":
      activeKey = "/innercircle";
      break;

    case "/entertainment":
      activeKey = "/innercircle";
      break;

    case "/suggestedactivities":
      activeKey = "/innercircle";
      break;

    case "/postsuggestions":
      activeKey = "/innercircle";
      break;

    case "/encouragementgroups":
      activeKey = "/encouragementgroups";
      break;

    case "/gratitudeattitude":
      activeKey = "/encouragementgroups";
      break;

    case "/notifications":
      activeKey = "/notifications";
      break;
    case "/managepros":
      activeKey = "/managepros";
      break;

    case "/profiledetail":
      activeKey = "/managepros";
      break;

    case "/directcare":
      activeKey = "/directcare";
      break;
    case "/reports":
      activeKey = "/reports";
      break;
    case "/postreport":
      activeKey = "/reports";
      break;
    case "/directcarereport":
      activeKey = "/reports";
      break;
    case "/innercirclereport":
      activeKey = "/reports";
      break;
    case "/usersreport":
      activeKey = "/reports";
      break;
    case "/settings":
      activeKey = "/settings";
      break;
    case "/tools":
      activeKey = "/tools";
      break;

    case "/logmood":
      activeKey = "/tools";
      break;

    case "/logthought":
      activeKey = "/tools";
      break;

    case "/meditation":
      activeKey = "/tools";
      break;

    case "/playlists":
      activeKey = "/tools";
      break;

    case "/resources":
      activeKey = "/resources";
      break;

    case "/ManagePros":
      activeKey = "/ManagePros";
      break;

    case "/Engagementfarming":
      activeKey = "/Engagementfarming";
      break;

    case "/profiledetail":
      activeKey = "/ManagePros";
      break;

    case "/ProPlans":
      activeKey = "/ProPlans";
      break;
  }
  const userType = localStorage.getItem("adminType") === "admin";
  let reportTabAccess = checkAccess("report-list") || userType;
  const innerTabAccess = checkAccess("get-inner-circle-list") || userType;

  const menuItems = [
    {
      key: "/organizations",
      label: "Organizations",
      icon:
        activeKey == "/organizations" ? (
          <img src={images.activeOrganizations} alt="" />
        ) : (
          <img src={images.organizations} alt="" />
        ),
    },
    {
      key: "/tools",
      label: "Tools and Resources",
      icon: <img src={images.tools} alt="" />,
      children: [
        {
          key: "/tools",
          label: "Tools",
          icon: activeKey == "/tools" && (
            <img src={images.ellipseTool} alt="" />
          ),
        },
        // {
        //   key: "/resources",
        //   label: "Resources",
        //   icon: activeKey == "/resources" && (
        //     <img src={images.ellipseTool} alt="" />
        //   ),
        // },
      ],
    },
    {
      key: "/users",
      label: "Users",
      icon:
        activeKey == "/users" ? (
          <img src={images.activeUser} alt="" />
        ) : (
          <img src={images.user} alt="" />
        ),
    },
    {
      key: "/community",
      label: "Community",
      icon:
        activeKey == "/community" ? (
          <img src={images.activeCommunity} alt="" />
        ) : (
          <img src={images.community} alt="" />
        ),
    },
    innerTabAccess && {
      key: "/innercircle",
      label: "Inner Circle",
      icon:
        activeKey == "/innercircle" ? (
          <img src={images.activeInnerCircle} alt="" />
        ) : (
          <img src={images.innerCircle} alt="" />
        ),
    },
    {
      key: "/encouragementgroups",
      label: "Encouragement Groups",
      icon:
        activeKey == "/encouragementgroups" ? (
          <img src={images.activeEncouragement} alt="" />
        ) : (
          <img src={images.encouragement} alt="" />
        ),
    },
    reportTabAccess && {
      key: "/reports",
      label: "Reports",
      icon:
        activeKey == "/reports" ? (
          <img src={images.activeReports} alt="" />
        ) : (
          <img src={images.reports} alt="" />
        ),
    },
    userType && {
      key: "/settings",
      label: "Settings",
      icon:
        activeKey == "/settings" ? (
          <img src={images.activeSettings} alt="" />
        ) : (
          <img src={images.settings} alt="settings" />
        ),
    },
    {
      key: "/notifications",
      label: "Notifications",
      icon:
        activeKey == "/notifications" ? (
          <img src={images.activeNotifications} alt="" />
        ) : (
          <img src={images.notifications} alt="settings" />
        ),
    },
    {
      key: "/directcare",
      label: "Bookings",
      icon:
        activeKey == "/directcare" ? (
          <img src={images.s1} alt="" />
        ) : (
          <img src={images.s1a} alt="directcare" />
        ),
    },
    {
      key: "/ManagePros",
      label: "Manage Pros",
      icon:
        activeKey == "/ManagePros" ? (
          <img src={images.Pros1} alt="" />
        ) : (
          <img src={images.Pros} alt="directcare" />
        ),
    },
    {
      key: "/Engagementfarming",
      label: "App Engagement",
      icon:
        activeKey == "/Engagementfarming" ? (
          <img src={images.activeReports} alt="" />
        ) : (
          <img src={images.reports} alt="directcare" />
        ),
    },
  ];

  return (
    <Sider
      // breakpoint="lg"
      className={props.isVisible ? "sider_left new closedd" : "sider_left new"}
      collapsedWidth="0"
      width={props.isVisible ? "108" : "250"}
      onBreakpoint={(broken) => {
        console.log(broken);
      }}
      onCollapse={(collapsed, type) => {
        console.log(collapsed, type);
      }}
    >
      <div className="min-slider">
        <div className="logo">
          <Link to="/organizations">
            <img src={images.logo} />
          </Link>
        </div>

        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          defaultOpenKeys={[activeKey]}
          selectedKeys={[activeKey]}
          onClick={(e) => onMenuClick(e)}
          items={menuItems}
        ></Menu>

        <div className="slider-bottom-section">
          <div
            onClick={() => {
              navigate("/messages");
            }}
            className={
              location.pathname === "/messages"
                ? "message-icons highlight-message-icon"
                : "message-icons"
            }
          >
            <img src={images.meessage} alt="bottMessage" className="w-[40px]" />
          </div>
          <Dropdown
            menu={{
              items,
            }}
            placement="top"
            trigger={["click"]}
          >
            <div className="user-option">
              <div className="user-icons-and-name">
                <p>
                  <span>
                    {" "}
                    <img src={images.nameIcons} alt="nameIcons" />{" "}
                  </span>{" "}
                  {localStorage.getItem("userName")}
                </p>
              </div>
              <div className="drowerr-icon">
                <img src={images.chevron} alt="chevron" />
              </div>
            </div>
          </Dropdown>
        </div>
      </div>

      <Modal
        title=""
        className="modal-update"
        destroyOnClose={true}
        centered
        visible={modal7Open}
        closable={true}
        onCancel={() => {
          formik.resetForm();
          setModal7Open(false);
        }}
        footer={null}
        width={400}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="add-user-popup">
            <div className="modal-add-user">
              <h1>Change Password</h1>
            </div>

            <div className="description-inner-circle">
              <div className="">
                <div className="form-group" style={{ marginBottom: "30px" }}>
                  <label>Old Password</label>
                  <Input.Password
                    {...formik.getFieldProps("oldPassword")}
                    autoComplete="off"
                    style={{ borderRadius: "10px" }}
                    className="form-control"
                    placeholder="Enter your password"
                  />
                  {formik.touched.oldPassword && formik.errors.oldPassword && (
                    <div className="error-text">
                      {formik.errors.oldPassword}
                    </div>
                  )}
                </div>

                <div className="form-group" style={{ marginBottom: "30px" }}>
                  <label>New Password</label>
                  <Input.Password
                    {...formik.getFieldProps("newPassword")}
                    autoComplete="off"
                    style={{ borderRadius: "10px" }}
                    className="form-control"
                    placeholder="Enter your new password"
                  />
                  {formik.touched.newPassword && formik.errors.newPassword && (
                    <div className="error-text">
                      {formik.errors.newPassword}
                    </div>
                  )}
                </div>

                <div className="form-group" style={{ marginBottom: "30px" }}>
                  <label>Confirm New Password</label>
                  <Input.Password
                    {...formik.getFieldProps("confirmPassword")}
                    autoComplete="off"
                    style={{ borderRadius: "10px" }}
                    className="form-control"
                    placeholder="Confirm your new password"
                  />
                  {formik.touched.confirmPassword &&
                    formik.errors.confirmPassword && (
                      <div className="error-text">
                        {formik.errors.confirmPassword}
                      </div>
                    )}
                </div>
              </div>
            </div>

            <div className="click-to-upload">
              <div className="create-admin">
                <button type="update">Create</button>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </Sider>
  );
};
export default Sidebar;
